import { useState, useCallback } from 'react';
import { turnosAPI } from '../../../core/api/api';
import { buildTurnosRequestBody } from '../../turnos/utils/turnoUtils';

export const useTurnos = () => {
  const [turnos, setTurnos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const cargarTurnos = useCallback(async (filtros) => {
    setLoading(true);
    setError('');

    try {
      const requestBody = buildTurnosRequestBody(filtros);
      const response = await turnosAPI.getTurnos(requestBody);
      setTurnos(response.data || []);
      return response.data;
    } catch (err) {
      const errorMsg = 'Error al cargar los turnos';
      setError(errorMsg);
      throw new Error(errorMsg);
    } finally {
      setLoading(false);
    }
  }, []);

  const cargarTodosTurnos = useCallback(async (filtros) => {
    setLoading(true);
    setError('');

    try {
      const requestBody = buildTurnosRequestBody(filtros);
      const response = await turnosAPI.getTodosTurnos(requestBody);
      
      console.log(response.data);
      setTurnos(response.data || []);
      return response.data;
    } catch (err) {
      const errorMsg = 'Error al cargar los turnos';
      setError(errorMsg);
      throw new Error(errorMsg);
    } finally {
      setLoading(false);
    }
  }, []);

  const getTurnoById = useCallback(async (idTurno) => {
    setLoading(true);
    setError('');

    try {
      const response = await turnosAPI.getTurnoById(idTurno);
      return response.data;
    } catch (err) {
      const errorMsg = 'Error al cargar los datos del turno';
      setError(errorMsg);
      throw new Error(errorMsg);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    turnos,
    loading,
    error,
    cargarTurnos,
    cargarTodosTurnos,
    getTurnoById,
    setError,
    setTurnos,
  };
};
